import React, { SFC } from 'react';
import SelectableListController from './selectable-list-controller';
import SelectableList from './selectable-list';
import { Props } from './types';

const SelectableListWrapper: SFC<Props> = props => (
  <SelectableListController {...props}>
    <SelectableList />
  </SelectableListController>
);

export default SelectableListWrapper;
